const viewportWidth = 750
export default (Vue) => {
  Vue.prototype.$pxToVW = (px) => {
    return (px / (viewportWidth / 100) ?? 0) + 'vw'
  }
  // Vue.prototype.$chartPx = (px) => {
  //   return (px / (viewportWidth / 100) ?? 0) + 'vw'
  // }
}
